import { createFileRoute } from '@tanstack/react-router'
import { AiSettingsView } from '@/features/settings/AiSettingsView'
import { TicketRefPrefixesView } from '@/features/settings/TicketRefPrefixesView'
import { SupportTeamView } from '@/features/settings/SupportTeamView'
import { SlaSettingsView } from '@/features/settings/SlaSettingsView'
import { AdminGuard } from '@/components/admin-guard'
import { AdminSubNav } from '@/components/shell/AdminSubNav'

export const Route = createFileRoute('/admin/settings')({
  component: () => (
    <AdminGuard>
      <AdminSubNav />
      <AiSettingsView />
      <SupportTeamView />
      <SlaSettingsView />
      <TicketRefPrefixesView />
    </AdminGuard>
  ),
})
